/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ResocontoCosti } from './resocontoCosti';
import { ResocontoPastiDipendenti } from './resocontoPastiDipendenti';
import { ResocontoPastiStudenti } from './resocontoPastiStudenti';

export interface GetPastiDaPreparareDTO { 
    totaliDipendenti?: ResocontoPastiDipendenti;
    scuoleDipendenti?: Array<ResocontoPastiDipendenti>;
    totaliStudenti?: Array<ResocontoPastiStudenti>;
    scuoleStudenti?: Array<ResocontoPastiStudenti>;
    resocontoCosti?: ResocontoCosti;
}